import { checkDiscount } from "../api/payments";
import { normalizeCode } from "./pendingDiscount";

// Game codes are 6 letters/digits (the server makes them; older ones could
// be 7). Website discount codes are longer, or carry "-" / "_".
export const looksLikeGameCode = (code) => /^[A-Z0-9]{6,7}$/.test(code);

export const INVALID_CODE_MESSAGE =
  "الكود غير صحيح. كود اللعبة 6 خانات تلقاه في لوحة التحكم أو التطبيق";

/**
 * Work out what a code typed into the website is.
 *
 * A game-shaped code is opened as a game straight away, as before: opening
 * one uses up a play, so it is never looked up just to check. (If it turns
 * out to be a discount code, the game page sends the visitor to pricing.)
 * Anything else is checked as a website discount code, which is read-only.
 *
 * @returns {Promise<{kind:"empty"|"game"|"discount"|"invalid", code?, message?, verified?}>}
 */
export async function resolveCode(raw) {
  const code = normalizeCode(raw);
  if (!code) return { kind: "empty" };
  if (looksLikeGameCode(code)) return { kind: "game", code };
  return checkAsDiscount(code);
}

export async function checkAsDiscount(code) {
  try {
    const res = await checkDiscount(code);
    if (res?.valid) return { kind: "discount", code: res.code || code, verified: true };
    // A real code that can't be used now (expired, fully used…) says why.
    const message =
      res?.reason && res.reason !== "not_found" ? res.message : INVALID_CODE_MESSAGE;
    return { kind: "invalid", code, message };
  } catch (e) {
    const status = e?.response?.status;
    if (status === 429) {
      return { kind: "invalid", code, message: "محاولات كثيرة، انتظر قليلاً ثم حاول" };
    }
    // The check isn't available: a code that isn't game-shaped is almost
    // certainly a discount code. The pricing page checks it after login.
    return { kind: "discount", code, verified: false };
  }
}
